import { useTranslation } from 'react-i18next';
import { MetaTags } from '@components/MetaTags';
import { useLocation } from 'react-router-dom';

import RecommendedForYouCarousel from '@pages/BlogsHomePage/components/RecommendedForYouCarousel';
import HeroSection from './components/HeroSection';
import heroImage from '@assets/images/blog/blog_whitepaper_download.jpg';
import DownloadSection from './components/DownloadSection';
import { ImageAndTextSection } from './components/ImageAndTextSection';
import blogWhitepaperDownloadImageText from '@assets/images/blog/blog_whitepaper_download_image_text.svg';

const BlogWhitepaperDownloadDetailPage = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const slug = pathname.split('/').filter(Boolean).pop() || '';

  return (
    <>
      <MetaTags
        title={`we.CONECT Global Leaders Group Blog Whitepaper Download Details`}
        description={`we.CONECT Global Leaders Group Blog Details`}
        keywords={`we.CONECT, ${slug?.split('-')?.join(', ')}`}
        image={`${window.location.origin}/1fdb62e88471bd6a3207.svg`}
        url={window.location.href}
        twitterCardType="summary"
        type="website"
      />

      <HeroSection src={heroImage} />

      <DownloadSection />

      <ImageAndTextSection
        orientation="right"
        sectionName="Teamwork"
        highlightText={t('download-now')}
        titleText={
          '“Building Your Digital Toolkit: How Small Businesses Can Work Smarter“'
        }
        paragraphs={[
          'Running a small business today means navigating a fast-changing digital landscape where the right tools make all the difference. From managing finances to connecting with customers, technology helps small teams operate with the precision of much larger organizations. The right digital setup can simplify your workflow, improve collaboration, and safeguard your business from costly disruptions. This guide breaks down the essential tools every small business should consider to grow efficiently and stay secure in a competitive market.',
        ]}
        imageURL={blogWhitepaperDownloadImageText}
        buttonText={t('download-now')}
        buttonURL={''}
      />

      <RecommendedForYouCarousel
        items={[
          {
            id: '1',
            description: 'Description 1',
            eventName: 'Event 1',
            link: `https://media.we-conect.com/images/website/home_keytopics_2.jpg`,
            themeColor: '#FF5733',
            textLeft: 'WEBINAR  REPORT | Networking',
            textRight: '15:42',
          },
          {
            id: '2',
            description: 'Description 1',
            eventName: 'Event 1',
            link: `https://media.we-conect.com/images/website/home_keytopics_2.jpg`,
            themeColor: '#FF5733',
            textLeft: 'WEBINAR  REPORT | Networking',
            textRight: '15:42',
          },
          {
            id: '3',
            description: 'Description 1',
            eventName: 'Event 1',
            link: `https://media.we-conect.com/images/website/home_keytopics_2.jpg`,
            themeColor: '#FF5733',
            textLeft: 'WEBINAR  REPORT | Networking',
            textRight: '15:42',
          },
          {
            id: '4',
            description: 'Description 1',
            eventName: 'Event 1',
            link: `https://media.we-conect.com/images/website/home_keytopics_2.jpg`,
            themeColor: '#FF5733',
            textLeft: 'WEBINAR  REPORT | Networking',
            textRight: '15:42',
          },
          {
            id: '5',
            description: 'Description 1',
            eventName: 'Event 1',
            link: `https://media.we-conect.com/images/website/home_keytopics_2.jpg`,
            themeColor: '#FF5733',
          },
        ]}
        title={t('recommended-for-you')}
      />
    </>
  );
};

export default BlogWhitepaperDownloadDetailPage;
